import { render, staticRenderFns } from "./RichTextDialog.vue?vue&type=template&id=88082de8&scoped=true"
import script from "./RichTextDialog.vue?vue&type=script&lang=js"
export * from "./RichTextDialog.vue?vue&type=script&lang=js"
import style0 from "./RichTextDialog.vue?vue&type=style&index=0&id=88082de8&prod&lang=less&scoped=true"
import style1 from "./RichTextDialog.vue?vue&type=style&index=1&id=88082de8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88082de8",
  null
  
)

export default component.exports